import { c as e, b as l, o as r } from "./vue.runtime.esm-bundler-CT4BZx-H.js";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function d(t, n) {
  return r(), e("svg", o, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.625 2a1 1 0 1 0 0 2h.59l-3.91 3.781a1 1 0 0 0 1.39 1.438l3.992-3.86V6a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1zM8 3.25h-.067c-.944 0-1.752 0-2.398.087-.69.092-1.342.3-1.87.828s-.736 1.18-.828 1.87c-.087.646-.087 1.454-.087 2.398v.134c0 .944 0 1.752.087 2.398.092.69.3 1.342.828 1.87s1.18.736 1.87.828c.646.087 1.454.087 2.398.087h.134c.944 0 1.752 0 2.398-.087.69-.092 1.342-.3 1.87-.828s.736-1.18.828-1.87c.087-.646.087-1.454.087-2.398V8.5a1 1 0 1 0-2 0c0 1.03-.002 1.702-.069 2.198-.063.468-.166.628-.26.723-.095.094-.255.197-.723.26-.496.067-1.168.069-2.198.069s-1.702-.002-2.198-.069c-.468-.063-.628-.166-.722-.26-.095-.095-.198-.255-.261-.723-.067-.496-.069-1.168-.069-2.198s.002-1.702.069-2.198c.063-.468.166-.628.26-.722.095-.095.255-.198.723-.261C6.298 5.252 6.97 5.25 8 5.25a1 1 0 1 0 0-2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const z1 = { render: d }, i = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function s(t, n) {
  return r(), e("svg", i, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      d: "M9.56 6.798 9.259 9.09a.25.25 0 0 1-.248.217H6.989a.25.25 0 0 1-.248-.217L6.44 6.798v-4.26a.25.25 0 0 1 .25-.25h2.62a.25.25 0 0 1 .25.25zm-1.2 4.14q.615 0 .84.24.24.225.24.84v.614q0 .615-.24.856-.225.225-.84.225h-.705q-.615 0-.855-.225-.225-.24-.225-.855v-.615q0-.615.225-.84.24-.24.855-.24z"
    }, null, -1)
  ]));
}
const A1 = { render: s }, a = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function c(t, n) {
  return r(), e("svg", a, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.75 11.178V3.94h-5.5v7.237l2.188-1.476c.34-.229.784-.229 1.124 0zm2-7.237v9.118a1 1 0 0 1-1.56.829L8 11.736l-3.19 2.152a1 1 0 0 1-1.56-.83V3.942a2 2 0 0 1 2-2h5.5a2 2 0 0 1 2 2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const S1 = { render: c }, h = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function u(t, n) {
  return r(), e("svg", h, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const V1 = { render: u }, w = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function v(t, n) {
  return r(), e("svg", w, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.707 2.293a1 1 0 1 0-1.414 1.414l4.293 4.291-4.288 4.296a1 1 0 1 0 1.415 1.412l4.995-5.002a1 1 0 0 0-.001-1.414zm5 0a1 1 0 1 0-1.414 1.414l4.293 4.291-4.288 4.296a1 1 0 1 0 1.415 1.412l4.995-5.002a1 1 0 0 0-.001-1.414z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const q1 = { render: v }, g = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function f(t, n) {
  return r(), e("svg", g, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.715 4.301a1 1 0 0 1-.016 1.414l-6.14 6a1 1 0 0 1-1.398 0L2.3 7.944A1 1 0 1 1 3.7 6.514l3.16 3.088 5.442-5.317a1 1 0 0 1 1.414.016",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const B1 = { render: f }, p = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function x(t, n) {
  return r(), e("svg", p, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13 8A5 5 0 1 1 3 8a5 5 0 0 1 10 0m-5 7A7 7 0 1 0 8 1a7 7 0 0 0 0 14m.75-9.875a.75.75 0 0 0-1.5 0v3.97l-.688-.688A.75.75 0 0 0 5.5 9.467l1.969 1.97a.75.75 0 0 0 1.06 0l1.97-1.97a.75.75 0 1 0-1.062-1.06l-.688.689z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const D1 = { render: x }, m = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function _(t, n) {
  return r(), e("svg", m, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.676 3.746a1 1 0 1 0-1.414-1.414l-1.37 1.37a6.06 6.06 0 0 0-2.95-.765c-1.836 0-3.249.818-4.244 1.73-.987.903-1.608 1.935-1.9 2.492a1.8 1.8 0 0 0-.005 1.678 9.4 9.4 0 0 0 1.675 2.289l-1.105 1.105a1 1 0 1 0 1.414 1.414l1.307-1.307c.8.431 1.752.724 2.858.724 1.833 0 3.259-.804 4.272-1.705 1.006-.894 1.65-1.918 1.961-2.481a1.8 1.8 0 0 0 0-1.752 9.8 9.8 0 0 0-1.668-2.208zM9.39 5.205a4 4 0 0 0-1.447-.268c-1.198 0-2.15.524-2.894 1.205-.705.645-1.182 1.4-1.434 1.86.23.427.65 1.102 1.268 1.71l1.187-1.188A2.002 2.002 0 0 1 8.524 6.07zm.545 2.283 1.158-1.158A7.7 7.7 0 0 1 12.373 8a7.6 7.6 0 0 1-1.487 1.862c-.765.68-1.737 1.2-2.944 1.2-.49 0-.94-.086-1.348-.233l.894-.895a2.003 2.003 0 0 0 2.446-2.446",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const P1 = { render: _ }, $ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function C(t, n) {
  return r(), e("svg", $, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.944 3.5a1.5 1.5 0 0 1 1.5-1.5H9.91c.3 0 .583.133.766.37.38.494.832 1.127 1.272 1.741.319.446.631.883.904 1.25.131.177.204.39.204.61V12.5a1.5 1.5 0 0 1-1.5 1.5H4.444a1.5 1.5 0 0 1-1.5-1.5zm8.112 3.508V12H4.944V4H9.4l.006.008v1.5a1.5 1.5 0 0 0 1.5 1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const T1 = { render: C }, M = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function I(t, n) {
  return r(), e("svg", M, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 3.992h5l-.488.65c-.6.8-.6 1.9 0 2.7l.487.65H5v-4m-2 .39v-.39a2 2 0 0 1 2-2h7.5a.75.75 0 0 1 .6 1.2l-.6.8-1.388 1.85a.25.25 0 0 0 0 .3l1.387 1.85.6.8a.75.75 0 0 1-.6 1.2H5v3.016a1 1 0 1 1-2 0V4.382",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const y1 = { render: I }, H = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function L(t, n) {
  return r(), e("svg", H, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.567 2.462a1.5 1.5 0 0 1 2.121 0l1.823 1.822a1.5 1.5 0 0 1 0 2.121l-6.947 6.947a1.5 1.5 0 0 1-.962.436l-2.52.165A1 1 0 0 1 2.02 12.89l.165-2.52a1.5 1.5 0 0 1 .436-.962zm-.272 3.1-5.127 5.127-.078 1.194 1.193-.079 5.128-5.127z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const F1 = { render: L }, k = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none"
};
function z(t, n) {
  return r(), e("svg", k, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      d: "M13.295 5.793a1 1 0 0 0-1.41 0L8 9.667 4.115 5.792a.998.998 0 0 0-1.41 1.412l3.88 3.88c.667.667 1 1 1.415 1 .414 0 .748-.333 1.414-1l3.88-3.88a1 1 0 0 0 0-1.411"
    }, null, -1)
  ]));
}
const R1 = { render: z }, A = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none"
};
function S(t, n) {
  return r(), e("svg", A, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      d: "M2.705 11.794c.39.39 1.02.39 1.41 0L8 7.919l3.885 3.877a.998.998 0 0 0 1.41-1.412l-3.88-3.88c-.667-.667-1-1-1.415-1-.414 0-.748.333-1.414 1l-3.88 3.88a1 1 0 0 0 0 1.41"
    }, null, -1)
  ]));
}
const b1 = { render: S }, V = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none"
};
function q(t, n) {
  return r(), e("svg", V, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      d: "M5 3.499a1 1 0 0 0-.001 1.41l3.876 3.884-3.876 3.885a.998.998 0 0 0 1.411 1.41l3.88-3.88c.668-.667 1-1 1-1.415 0-.414-.332-.747-1-1.414L6.41 3.5a1 1 0 0 0-1.41 0"
    }, null, -1)
  ]));
}
const j1 = { render: q }, B = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none"
};
function D(t, n) {
  return r(), e("svg", B, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      d: "M11 14.088a1 1 0 0 0 .001-1.41L7.125 8.793l3.876-3.884a.998.998 0 0 0-1.411-1.41l-3.88 3.88c-.667.667-1 1-1 1.414 0 .415.333.748 1 1.415l3.88 3.88a.997.997 0 0 0 1.41 0"
    }, null, -1)
  ]));
}
const U1 = { render: D }, P = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function T(t, n) {
  return r(), e("svg", P, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 1.312a3.5 3.5 0 0 0-3.5 3.5v1.876h-.923A.57.57 0 0 0 3 7.25v4.438c0 1.657 1.344 3 3 3H10c1.657 0 3.001-1.343 3.001-3V7.25a.57.57 0 0 0-.577-.562H11.5V4.812a3.5 3.5 0 0 0-3.5-3.5m1.5 5.376V4.812a1.5 1.5 0 0 0-3 0v1.876z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const W1 = { render: T }, y = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function F(t, n) {
  return r(), e("svg", y, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.707 8.707a1 1 0 0 0-1.414-1.414l-3.294 3.295V3a1 1 0 1 0-2 0v7.585L3.707 7.298a1 1 0 0 0-1.414 1.415l5.003 4.995a1 1 0 0 0 1.414-.001z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const E1 = { render: F }, R = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function b(t, n) {
  return r(), e("svg", R, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.293 7.293a1 1 0 1 0 1.414 1.414l3.294-3.295V13a1 1 0 1 0 2 0V5.415l3.293 3.287a1 1 0 1 0 1.412-1.415L8.705 2.292a1 1 0 0 0-1.414.001z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const N1 = { render: b }, j = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function U(t, n) {
  return r(), e("svg", j, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.293 2.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L10.586 9H3a1 1 0 0 1 0-2h7.586L7.293 3.707a1 1 0 0 1 0-1.414",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const G1 = { render: U }, W = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function E(t, n) {
  return r(), e("svg", W, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.707 2.293a1 1 0 0 1 0 1.414L5.414 7H13a1 1 0 1 1 0 2H5.414l3.293 3.293a1 1 0 1 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const J1 = { render: E }, N = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function G(t, n) {
  return r(), e("svg", N, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 1.312a3.5 3.5 0 0 0-3.5 3.5h2a1.5 1.5 0 0 1 3 0v1.876H3.577A.57.57 0 0 0 3 7.25v4.438c0 1.657 1.344 3 3 3H10c1.657 0 3.001-1.343 3.001-3V7.25a.57.57 0 0 0-.577-.562H11.5V4.812a3.5 3.5 0 0 0-3.5-3.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const K1 = { render: G }, J = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function K(t, n) {
  return r(), e("svg", J, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.929 8a1 1 0 0 1 1-1H7V2.929a1 1 0 0 1 2 0V7h4.071a1 1 0 0 1 0 2H9v4.071a1 1 0 1 1-2 0V9H2.929a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const O1 = { render: K }, O = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function Q(t, n) {
  return r(), e("svg", O, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.05 3.949a1 1 0 1 0 0 2h9.9a1 1 0 1 0 0-2h-9.9M5.97 10.05a1 1 0 1 0 0 2h4.062a1 1 0 0 0 0-2H5.97",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Q1 = { render: Q }, X = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function Y(t, n) {
  return r(), e("svg", X, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.717 3.404a1.69 1.69 0 0 1 1.998-1.397l5.401 1.037a1.813 1.813 0 0 1 1.44 2.057l-.88 5.43a1.69 1.69 0 0 1-1.135 1.343V8.16l.541-3.343a.26.26 0 0 0-.205-.293L6.475 3.487a.24.24 0 0 0-.285.2l-.13.806H4.54zM3.04 5.994a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const X1 = { render: Y }, Z = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function n1(t, n) {
  return r(), e("svg", Z, n[0] || (n[0] = [
    l("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M8 3a5 5 0 1 0 0 10A5 5 0 0 0 8 3M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 2a1 1 0 0 1 1-1 7 7 0 0 1 5.163 11.728 1 1 0 0 1-1.475-1.352A5 5 0 0 0 8 3a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Y1 = { render: n1 }, l1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function e1(t, n) {
  return r(), e("svg", l1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m-.723-3.518 3.099-2.066a.5.5 0 0 0 0-.832L7.277 5.518a.5.5 0 0 0-.777.416v4.132a.5.5 0 0 0 .777.416",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Z1 = { render: e1 }, r1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function t1(t, n) {
  return r(), e("svg", r1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.826 2.911a.787.787 0 0 1 1.574 0v.448h2.931a.787.787 0 1 1 0 1.572h-.705c-.286.808-.744 2.063-1.907 3.376l.085.088.15.157.358.362c.078.081.207.231.273.43a.75.75 0 0 1-.145.745l-.01.012-.011.011a.77.77 0 0 1-.392.217.76.76 0 0 1-.387-.024 1.2 1.2 0 0 1-.461-.299l-.354-.358-.158-.165-.05-.051-2.264 2.26a.788.788 0 0 1-1.113-1.113L5.526 8.3c-.512-.58-.905-1.147-1.197-1.729a.786.786 0 1 1 1.408-.704c.207.412.492.838.89 1.3a7.5 7.5 0 0 0 1.321-2.235H2.912a.787.787 0 1 1 0-1.572h2.914zm4.984 3.566c.324 0 .616.197.735.499l1.428 3.633.85 2.197a.786.786 0 1 1-1.47.566l-.654-1.694H9.94l-.67 1.7a.787.787 0 0 1-1.465-.578l.866-2.192v-.002l1.408-3.627a.79.79 0 0 1 .732-.502m.007 2.95-.264.68h.531z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const n0 = { render: t1 }, o1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function d1(t, n) {
  return r(), e("svg", o1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.953 6.348a1 1 0 1 0 1.165-1.625L8.583 2.187a1 1 0 0 0-1.166 0L3.882 4.723a1 1 0 1 0 1.165 1.625L8 4.231zM5.047 9.723a1 1 0 1 0-1.165 1.625l3.535 2.536a1 1 0 0 0 1.166 0l3.535-2.536a1 1 0 1 0-1.165-1.625L8 11.84z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const l0 = { render: d1 }, i1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function s1(t, n) {
  return r(), e("svg", i1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      d: "M8.201 2.625q.615 0 .84.24.24.225.24.84v.615q0 .615-.24.855-.225.225-.84.225h-.705q-.615 0-.855-.225-.225-.24-.225-.855v-.615q0-.615.225-.84.24-.24.855-.24zM8.281 13.484a1 1 0 0 0 1-1v-4.97a1 1 0 0 0-1-1H6.844c-1.204 0-1.25.56-1.25 1.25 0 .67 0 1.249 1.19 1.249v3.471a1 1 0 0 0 1 1z"
    }, null, -1)
  ]));
}
const e0 = { render: s1 }, a1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function c1(t, n) {
  return r(), e("svg", a1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 8a4 4 0 0 1 4-4 1 1 0 0 0 0-2 6 6 0 1 0 5.827 7.437 1 1 0 0 0-1.943-.478A4 4 0 0 1 4 8m9.27-2.48a1 1 0 0 0-1.415-1.415L8.094 7.867 7.035 6.809a1 1 0 1 0-1.414 1.414l1.766 1.765a1 1 0 0 0 1.414 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const r0 = { render: c1 }, h1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function u1(t, n) {
  return r(), e("svg", h1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.942 2.937c-1.836 0-3.249.818-4.244 1.73-.987.903-1.608 1.935-1.9 2.492a1.8 1.8 0 0 0-.005 1.678c.29.558.906 1.592 1.892 2.496.996.914 2.411 1.73 4.257 1.73 1.833 0 3.259-.805 4.272-1.706 1.006-.894 1.65-1.918 1.961-2.481a1.8 1.8 0 0 0 0-1.752c-.31-.563-.955-1.587-1.96-2.481-1.014-.901-2.44-1.706-4.273-1.706M5.037 9.86c-.702-.644-1.174-1.395-1.423-1.856.252-.462.729-1.216 1.434-1.861.744-.681 1.696-1.205 2.894-1.205 1.207 0 2.18.521 2.944 1.2A7.6 7.6 0 0 1 12.373 8a7.6 7.6 0 0 1-1.487 1.862c-.765.68-1.737 1.2-2.944 1.2-1.21 0-2.165-.524-2.905-1.203",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const t0 = { render: u1 }, w1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function v1(t, n) {
  return r(), e("svg", w1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.929 8a1 1 0 0 1 1-1H13.07a1 1 0 0 1 0 2H2.93a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const o0 = { render: v1 }, g1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function f1(t, n) {
  return r(), e("svg", g1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.293 3.293a1 1 0 0 1 1.414 0L8 6.586l3.293-3.293a1 1 0 1 1 1.414 1.414L9.414 8l3.293 3.293a1 1 0 0 1-1.414 1.414L8 9.414l-3.293 3.293a1 1 0 0 1-1.414-1.414L6.586 8 3.293 4.707a1 1 0 0 1 0-1.414",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d0 = { render: f1 }, p1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function x1(t, n) {
  return r(), e("svg", p1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.929 3.898a1 1 0 0 1 1-1H13.07a1 1 0 1 1 0 2H2.929a1 1 0 0 1-1-1m0 4.125a1 1 0 0 1 1-1H13.07a1 1 0 1 1 0 2H2.929a1 1 0 0 1-1-1m1 3.03a1 1 0 1 0 0 2H6.99a1 1 0 1 0 0-2H2.93",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i0 = { render: x1 }, m1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function _1(t, n) {
  return r(), e("svg", m1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.406 2.75a1 1 0 0 0-2 0v1H4a2 2 0 0 0-2 2v6.5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.5a2 2 0 0 0-2-2h-.562v-1a1 1 0 1 0-2 0v1H6.406zM4 5.75h8v6.5H4zm4.969 2.969a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 0-.5-.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const s0 = { render: _1 }, $1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function C1(t, n) {
  return r(), e("svg", $1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      d: "M2.04 10.469V5.472h1.357v4.997zM8.722 7.864q0 1.251-.69 1.928-.687.677-1.935.677H4.48V5.472h1.73q1.202 0 1.856.615.656.615.656 1.777m-1.401.048q0-.687-.274-1.018-.27-.332-.823-.332H5.83v2.8h.3q.615-.001.903-.356.287-.36.287-1.094M12.427 5.472h1.511l-1.637 4.997h-1.59l-1.63-4.997H10.6l.68 2.532q.212.845.232 1.176a9.665 9.665 0 0 1 .222-1.162z"
    }, null, -1)
  ]));
}
const a0 = { render: C1 }, M1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function I1(t, n) {
  return r(), e("svg", M1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      d: "M9 6.469a1 1 0 0 0-2 0V8.03a1 1 0 0 0 .236.646l1.36 1.608a1 1 0 1 0 1.528-1.291L9 7.665z"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.063 2.063a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-4 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c0 = { render: I1 }, H1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};
function L1(t, n) {
  return r(), e("svg", H1, n[0] || (n[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.324 12.285a1 1 0 1 0 1.414 1.414L13.7 3.74a1 1 0 1 0-1.414-1.415zm6.914.008a1 1 0 0 0 1.414 1.414l3.032-3.031a1 1 0 0 0-1.415-1.414z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const h0 = { render: L1 };
export {
  E1 as ArrowBottom16StrokeIcon,
  J1 as ArrowLeftIcon,
  G1 as ArrowRightIcon,
  R1 as ArrowSimpleBottom16StrokeIcon,
  U1 as ArrowSimpleLeft16StrokeIcon,
  j1 as ArrowSimpleRight16StrokeIcon,
  b1 as ArrowSimpleTop16StrokeIcon,
  N1 as ArrowTopIcon,
  S1 as Bookmark16StrokeIcon,
  s0 as Calendar16pxIcon,
  X1 as CasCliniquesIcon,
  A1 as Caution216StrokeIcon,
  B1 as Check16StrokeIcon,
  r0 as CheckValidIcon,
  V1 as Circle16StrokeIcon,
  d0 as CrossSmallIcon,
  q1 as Deploy16StrokeIcon,
  D1 as Download16StrokeIcon,
  Y1 as DownloadProgressIcon,
  T1 as Draft16StrokeIcon,
  Q1 as FilterIcon,
  y1 as Flag16StrokeIcon,
  a0 as IDVIcon,
  e0 as InformationIcon,
  o0 as LessIcon,
  z1 as Link16StrokeIcon,
  W1 as Lock16StrokeIcon,
  O1 as MoreIcon,
  F1 as Pen16StrokeIcon,
  c0 as PendingIcon,
  Z1 as PlayIcon,
  P1 as ShowClose16StrokeIcon,
  t0 as ShowIcon,
  l0 as SortIcon,
  i0 as TextIcon,
  n0 as TranslateIcon,
  K1 as UnlockIcon,
  h0 as WristIcon
};
//# sourceMappingURL=stroke16.js.map
